import styled from 'styled-components';
import Sliders from '../components/Sliders';
import Slider from '../components/work/Slider';
import { workDesc } from '../components/work/workList';
function Work() {
  return (
    <Wrap>
      {workDesc.map((workData, i) => {
        if (i === 0) {
          return (
            <BG reverse={false} url={workData.imgUrl}>
              <BGInner reverse={false}>
                <Slider index={i} />
              </BGInner>
            </BG>
          );
        } else {
          return (
            <BG reverse={true} url={workData.imgUrl}>
              <BGInner reverse={true}>
                <Slider index={i} />
              </BGInner>
            </BG>
          );
        }
      })}
    </Wrap>
  );
}

const WorKTitle = styled.div`
  color: #f1bf78;
  font-size: 16px;
  text-align: left;
`;
const WorkContent = styled.div`
  width: 70%;
  z-index: 10;
  margin: 0 auto;
  padding: 60px 0;

  @media only screen and (max-width: 750px) {
    padding: 40px 0 10px 0;
  }
`;
const Title = styled.h2`
  color: #ffff;
  padding-top: 50px;
  color: #f1bf78;
  position: relative;
  display: inline-block;
  font-size: 25px;
  /* font-family: 'Playfair Display', serif; */
  /* font-style: italic; */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
  }
`;
const BGInner = styled.div`
  width: 100%;
  background: linear-gradient(
    -45deg,
    rgba(0, 0, 0, 0.4) 30%,
    rgba(17, 22, 33, 0.9) 70%
  );
  ${props =>
    props.reverse &&
    `background: linear-gradient(45deg, rgba(0, 0, 0, 0.4) 30%, rgba(17, 22, 33, 0.9) 70%);`}
  background-size: cover;
  height: 100%;
  @media only screen and (max-width: 740px) {
  }
`;
const BG = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
  background: url(${props => props.url}) no-repeat;
  background-size: cover;
  ${props =>
    props.reverse && `background:url(${props => props.url}) no-repeat;`}
  background-attachment: fixed;
  @media only screen and (max-width: 740px) {
    background-size: auto 740px;
    background-attachment: initial;
  }
`;
const Wrap = styled.div``;

export default Work;
